<template lang="pug">
#news_detail
  .main_container.container
    breadcrumb(v-bind:pageName="pageName")
    .card-body
      .ck-content(v-html="newsDetail.content")
  custom-footer
</template>

<script>
import CustomFooter from "@/components/common/Footer";
import Breadcrumb from "@/components/common/Breadcrumb";
import { getNewsDetail } from "@/api/web_content";

export default {
  name: "NewsDetail",
  components: {
    "custom-footer": CustomFooter,
    breadcrumb: Breadcrumb,
  },
  data() {
    return {
      pageName: "最新消息",
      newsDetail: {},
    };
  },
  created() {
    this.getNewsDetail(this.$route.query.id);
  },
  methods: {
    getNewsDetail(id) {
      getNewsDetail(id).then((response) => {
        this.newsDetail = response.data;
      });
    },
  },
};
</script>

<style scoped lang="scss">
#news_detail {
  background-color: $color_bg_white;
  min-height: calc(100vh - 80px);
  position: relative;
}
</style>
